import { render, staticRenderFns } from "./WebhookSettings.vue?vue&type=template&id=505b0684&"
import script from "./WebhookSettings.vue?vue&type=script&lang=js&"
export * from "./WebhookSettings.vue?vue&type=script&lang=js&"
import style0 from "./WebhookSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('505b0684')) {
      api.createRecord('505b0684', component.options)
    } else {
      api.reload('505b0684', component.options)
    }
    module.hot.accept("./WebhookSettings.vue?vue&type=template&id=505b0684&", function () {
      api.rerender('505b0684', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/settings/WebhookSettings.vue"
export default component.exports